<template>
  <el-drawer
    :title="'通道管理 · ' + (nvr ? nvr.name : '')"
    :visible.sync="visible"
    size="720px"
    append-to-body
    :before-close="close"
  >
    <div class="ch-wrap" v-if="nvr">
      <div class="ch-ops">
        <el-button size="small" icon="el-icon-refresh" :loading="syncing" @click="syncChannels">从 NVR 同步通道</el-button>
        <el-button size="small" icon="el-icon-document" @click="openAudit">变更记录</el-button>
        <span class="ch-tip">保存后最长 30s 内自动生效</span>
      </div>
      <el-table :data="channels" v-loading="loading" size="mini" stripe max-height="520">
        <el-table-column prop="channel" label="通道" width="60" align="center" sortable />
        <el-table-column prop="name" label="名称" min-width="170">
          <template slot-scope="{ row }">
            <el-input v-model="row.name" size="mini" @change="saveCh(row)" />
          </template>
        </el-table-column>
        <el-table-column prop="code" label="码流" width="70" align="center" />
        <el-table-column label="可拉流" width="80" align="center">
          <template slot-scope="{ row }">
            <span class="ch-dot" :class="row.pullable ? 'on' : 'off'"></span>
            {{ row.pullable ? '可拉流' : '未接入' }}
          </template>
        </el-table-column>
        <el-table-column label="云台" width="86" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.support_ptz === 1" size="mini" type="success">支持</el-tag>
            <el-tag v-else-if="row.support_ptz === 0" size="mini" type="info">不支持</el-tag>
            <el-tag v-else size="mini" type="warning">未知</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="76" align="center">
          <template slot-scope="{ row }">
            <el-input-number v-model="row.sort" size="mini" :min="0" :controls="false" style="width:54px" @change="saveCh(row)" />
          </template>
        </el-table-column>
        <el-table-column label="启用" width="66" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.enabled" :active-value="1" :inactive-value="0" @change="saveCh(row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="变更记录" :visible.sync="auditDlg" width="680px" append-to-body>
      <el-table :data="auditList" size="mini" v-loading="auditLoading" max-height="420">
        <el-table-column prop="create_time" label="时间" width="150" />
        <el-table-column prop="target_type" label="对象" width="70" align="center" />
        <el-table-column prop="action" label="动作" width="120" />
        <el-table-column prop="result" label="结果" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.result === 'SUCCESS' ? 'success' : 'danger'" size="mini">{{ row.result }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="说明" min-width="150" show-overflow-tooltip />
      </el-table>
    </el-dialog>
  </el-drawer>
</template>

<script>
import videoAPI from '@/api/video'

export default {
  name: 'NvrChannelDrawer',
  props: {
    nvr: { type: Object, default: null }
  },
  data() {
    return {
      visible: false,
      loading: false,
      syncing: false,
      auditDlg: false,
      auditLoading: false,
      channels: [],
      auditList: []
    }
  },
  methods: {
    open() {
      this.visible = true
      this.load()
    },
    close() {
      this.visible = false
      this.channels = []
    },
    async load() {
      if (!this.nvr || !this.nvr.id) return
      this.loading = true
      try {
        const r = await videoAPI.cfgListChannels({ nvrId: this.nvr.id })
        this.channels = r.data || []
      } catch (e) { this.channels = [] } finally { this.loading = false }
    },
    async saveCh(row) {
      try {
        await videoAPI.cfgUpdateChannel(row.id, { name: row.name, sort: row.sort, enabled: row.enabled })
        this.$message.success('通道 ' + row.channel + ' 已保存')
      } catch (e) { this.$message.error('保存失败') }
    },
    async syncChannels() {
      if (!this.nvr || !this.nvr.id) return
      this.syncing = true
      try {
        const r = await videoAPI.cfgSyncChannels(this.nvr.id)
        if (r.data && r.data.ok) {
          this.$message.success('同步完成：新增 ' + r.data.added + '，更新 ' + r.data.updated)
          this.load()
        } else {
          this.$message.warning('同步失败：' + ((r.data && r.data.err) || ''))
        }
      } catch (e) { this.$message.error('同步失败') } finally { this.syncing = false }
    },
    async openAudit() {
      this.auditDlg = true
      this.auditLoading = true
      try {
        const r = await videoAPI.cfgAudit({ targetId: this.nvr.id, targetType: 'NVR' })
        this.auditList = r.data || []
      } catch (e) { this.auditList = [] } finally { this.auditLoading = false }
    }
  }
}
</script>

<style scoped>
.ch-wrap { padding: 0 16px; }
.ch-ops { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
.ch-tip { color: #94a3b8; font-size: 12px; }
.ch-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 4px; vertical-align: middle; }
.ch-dot.on { background: #22c55e; }
.ch-dot.off { background: #cbd5e1; }
</style>
